// extracted by mini-css-extract-plugin
module.exports = {"table_title":"Overview_table_title__Ulbmv","status_color":"Overview_status_color__Jipai","body_text":"Overview_body_text__2AI6u","header_text":"Overview_header_text__3ddu_"};